import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SalesLetter() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="py-16 px-4 max-w-3xl mx-auto text-gray-300 text-lg space-y-10 leading-relaxed mt-10 md:mt-0" data-id="element-203">
      <p className="italic text-gray-400" data-id="element-204">
        Desde la experiencia de alguien que pasó{' '}
        <span className="font-bold text-white" data-id="element-205">EXACTAMENTE</span> por lo mismo…
      </p>
      <p className="font-bold text-white text-xl" data-id="element-206">
        Control sexual masculino (hecho simple)
      </p>

      <p data-id="element-207">Querido hombre que quiere durar más…</p>
      <p data-id="element-208">Déjame preguntarte algo…</p>

      <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl space-y-5 shadow-lg my-12" data-id="element-209">
        <h3 className="text-2xl font-heading text-white mb-4" data-id="element-210">¿Alguna vez…?</h3>
        <ul className="space-y-4" data-id="element-211">
          <li className="flex items-start" data-id="element-212">
            <span className="mr-4 mt-1 text-brand-red text-xl" data-id="element-213"></span>
            <span data-id="element-214">
              ¿Terminaste demasiado rápido y después te quedaste con esa
              sensación de frustración?
            </span>
          </li>
          <li className="flex items-start" data-id="element-215">
            <span className="mr-4 mt-1 text-brand-red text-xl" data-id="element-216"></span>
            <span data-id="element-217">
              ¿Sentiste que podrías haber durado más… pero tu cuerpo no
              respondió?
            </span>
          </li>
          <li className="flex items-start" data-id="element-218">
            <span className="mr-4 mt-1 text-brand-red text-xl" data-id="element-219"></span>
            <span data-id="element-220">
              ¿Te pusiste nervioso antes de estar con una mujer por miedo a
              fallar?
            </span>
          </li>
          <li className="flex items-start" data-id="element-221">
            <span className="mr-4 mt-1 text-brand-red text-xl" data-id="element-222"></span>
            <span data-id="element-223">¿Intentaste “controlarte” pero no funcionó?</span>
          </li>
          <li className="flex items-start" data-id="element-224">
            <span className="mr-4 mt-1 text-brand-red text-xl" data-id="element-225"></span>
            <span data-id="element-226">
              ¿Te comparaste con otros hombres y sentiste que estás por debajo?
            </span>
          </li>
        </ul>
      </div>

      <div className="text-center py-8" data-id="element-227">
        <p className="text-2xl text-white italic font-medium" data-id="element-228">
          Y esto no es tu culpa.
        </p>
      </div>

      <p data-id="element-229">
        Estos son <span className="font-bold text-white" data-id="element-230">EXACTAMENTE</span> los
        problemas que yo tenía…
      </p>
      <p data-id="element-231">
        …y son los mismos que{' '}
        <span className="font-bold text-white" data-id="element-232">miles de hombres</span> siguen
        teniendo hoy.
      </p>

      <div className="text-center py-12" data-id="element-233">
        <h2 className="text-3xl md:text-4xl font-heading text-white uppercase" data-id="element-234">
          “DURAR MÁS NO DEBERÍA SER TAN DIFÍCIL…”
        </h2>
        <p className="mt-6 text-xl" data-id="element-235">Pero lo es.</p>
        <p className="text-xl" data-id="element-236">Y no por tu culpa.</p>
      </div>

      <h2 className="text-3xl font-heading text-brand-red uppercase mt-8" data-id="element-237">
        ACÁ ESTÁ EL VERDADERO PROBLEMA…
      </h2>
      <p data-id="element-238">Cuando empecé a buscar soluciones…</p>
      <p data-id="element-239">Probé TODO.</p>
      <p data-id="element-240">Y descubrí algo que me frustró más que el problema en sí:</p>

      <h3 className="text-2xl font-bold text-white mt-12 mb-6" data-id="element-241">
        ❌ LA MAYORÍA DE LAS SOLUCIONES SON COMPLETA BASURA
      </h3>
      <p data-id="element-242">Sí. Basura.</p>
      <p data-id="element-243">Te explico por qué:</p>

      <ul className="space-y-4 mt-6 bg-gray-900/50 p-6 rounded-xl border border-gray-800" data-id="element-244">
        <li className="flex items-start" data-id="element-245">
          <XCircleIcon className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-246" />
          <span data-id="element-247">Consejos genéricos que no funcionan en el momento real</span>
        </li>
        <li className="flex items-start" data-id="element-248">
          <XCircleIcon className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-249" />
          <span data-id="element-250">Técnicas incompletas que dejan todo a la suerte</span>
        </li>
        <li className="flex items-start" data-id="element-251">
          <XCircleIcon className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-252" />
          <span data-id="element-253">Métodos que asumen que ya tenés control</span>
        </li>
        <li className="flex items-start" data-id="element-254">
          <XCircleIcon className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-255" />
          <span data-id="element-256">Información suelta sin orden ni sistema</span>
        </li>
        <li className="flex items-start" data-id="element-257">
          <XCircleIcon className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-258" />
          <span data-id="element-259">
            Soluciones externas (pastillas, trucos) que{' '}
            <span className="font-bold underline text-white" data-id="element-260">
              NO resuelven la raíz
            </span>
          </span>
        </li>
      </ul>

      <div className="text-center py-10" data-id="element-261">
        <p className="text-2xl text-white font-bold" data-id="element-262">Pero hay un problema…</p>
      </div>

      <div className="bg-gray-900 border-l-4 border-brand-red p-8 my-10 rounded-r-xl" data-id="element-263">
        <p className="font-bold text-white mb-3 text-xl" data-id="element-264">
          👉 Es como si te dijeran:
        </p>
        <p className="italic text-xl text-gray-400" data-id="element-265">“Bueno… arreglate solo.”</p>
      </div>

      <p data-id="element-266">No es raro que tantos hombres…</p>
      <div className="flex flex-col md:flex-row md:space-x-8 space-y-3 md:space-y-0 font-medium text-white text-lg mb-12" data-id="element-267">
        <span data-id="element-268">👉 Sigan igual durante años</span>
        <span data-id="element-269">👉 Pierdan confianza</span>
        <span data-id="element-270">👉 Eviten situaciones</span>
      </div>

      <hr className="border-gray-800 opacity-20 my-16" data-id="element-271" />

      <div className="text-center py-8" data-id="element-272">
        <p className="text-2xl text-brand-green font-bold" data-id="element-273">
          👉 Y esto cambia todo.
        </p>
      </div>

      <h2 className="text-3xl font-heading text-brand-green uppercase mt-8" data-id="element-274">
        💡 ASÍ QUE DECIDÍ SOLUCIONAR TODO ESO…
      </h2>
      <p data-id="element-275">Después de probar, fallar, entender…</p>
      <p data-id="element-276">Y ver patrones reales…</p>

      <p className="text-2xl text-white text-center py-10" data-id="element-277">
        Construí un sistema <span className="font-bold" data-id="element-278">SIMPLE</span>,{' '}
        <span className="underline" data-id="element-279">DIRECTO</span> y{' '}
        <span className="italic" data-id="element-280">FUNCIONAL</span>
      </p>

      <div className="bg-gray-900 border border-brand-green/30 p-8 rounded-2xl space-y-6 shadow-[0_0_15px_rgba(22,163,74,0.1)] my-12" data-id="element-281">
        <p className="font-bold text-white mb-2 text-xl" data-id="element-282">
          👉 ¿Y si te dijera que podés…?
        </p>
        <ul className="space-y-4" data-id="element-283">
          <li className="flex items-start" data-id="element-284">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-4 flex-shrink-0 mt-1" data-id="element-285" />
            <span data-id="element-286">Durar 10, 20 o incluso 30+ minutos</span>
          </li>
          <li className="flex items-start" data-id="element-287">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-4 flex-shrink-0 mt-1" data-id="element-288" />
            <span data-id="element-289">Controlar exactamente cuándo terminar</span>
          </li>
          <li className="flex items-start" data-id="element-290">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-4 flex-shrink-0 mt-1" data-id="element-291" />
            <span data-id="element-292">Eliminar la ansiedad en el momento</span>
          </li>
          <li className="flex items-start" data-id="element-293">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-4 flex-shrink-0 mt-1" data-id="element-294" />
            <span data-id="element-295">Y mejorar tu rendimiento desde la primera vez</span>
          </li>
        </ul>
      </div>

      <div className="text-center pt-20 pb-12 border-t border-gray-800 mt-16" data-id="element-296">
        <h2 className="text-2xl text-brand-red font-bold mb-4 tracking-widest" data-id="element-297">
          🔥 INTRODUCIENDO…
        </h2>
        <h1 className="text-5xl md:text-6xl font-heading text-white uppercase mb-8 leading-tight" data-id="element-298">
          MÉTODO CONTROL TOTAL
        </h1>
        <p className="text-2xl text-gray-300 italic" data-id="element-299">
          El sistema paso a paso para dominar tu rendimiento… incluso si hoy
          durás minutos
        </p>
      </div>

      <div className="flex flex-col items-center justify-center my-12 space-y-3" data-id="element-300">
        <a href="[CART_LINK]" className="inline-block bg-brand-red hover:bg-brand-redHover text-white font-heading text-2xl py-5 px-10 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-301">
          QUIERO ACCESO AHORA
        </a>
        <p className="text-sm text-gray-500 font-medium" data-id="element-302">
          ⚡ Acceso inmediato después del pago
        </p>
      </div>

      <div className="text-center text-brand-gold font-bold text-xl md:text-2xl uppercase tracking-widest border-y border-gray-800 py-6 my-16" data-id="element-303">
        🌎 EL SISTEMA MÁS COMPLETO DE CONTROL SEXUAL
      </div>

      <div className="bg-gray-900 p-8 rounded-2xl mb-16 border border-gray-800" data-id="element-304">
        <h3 className="text-2xl font-bold text-white mb-6" data-id="element-305">
          📦 ¿QUÉ HACE PERFECTO ESTE MÉTODO?
        </h3>
        <p className="mb-6 text-gray-400" data-id="element-306">Un sistema real debe:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-307">
          <div className="flex items-center text-lg" data-id="element-308">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-3" data-id="element-309" />
            <span className="font-medium text-white" data-id="element-310">
              No dejar nada al azar
            </span>
          </div>
          <div className="flex items-center text-lg" data-id="element-311">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-3" data-id="element-312" />
            <span className="font-medium text-white" data-id="element-313">
              Ser claro desde el inicio hasta el final
            </span>
          </div>
          <div className="flex items-center text-lg" data-id="element-314">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-3" data-id="element-315" />
            <span className="font-medium text-white" data-id="element-316">
              Funcionar en la práctica
            </span>
          </div>
          <div className="flex items-center text-lg" data-id="element-317">
            <CheckCircleIcon className="w-6 h-6 text-brand-green mr-3" data-id="element-318" />
            <span className="font-medium text-white" data-id="element-319">
              Adaptarse a cualquier nivel
            </span>
          </div>
        </div>
      </div>

      <h2 className="text-3xl font-heading text-white uppercase text-center mb-10" data-id="element-320">
        🔍 MIRÁ POR QUÉ ESTE SISTEMA ES 10X MEJOR:
      </h2>
    </motion.section>;
}